import { BehaviorSubject, Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ResizeService {

    private __behavioursubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private __isViewOpen: boolean = false;
    private __isFormOpen: boolean = false;
    private __isFormBig: boolean = false;
    private __isImportOpen: boolean = false;
    private __size:any;
    private __mobileSidebar: boolean = false;
    private __vertical: boolean = false;

    Cast: Observable<any> = new Observable<any>();


    constructor() {
        this.init();
    }
    private init() {
        this.Cast = this.__behavioursubject.asObservable();
    }
    private nextCast(_trg) {
        this.__size = _trg;
        this.__behavioursubject.next(_trg);
    }

    UpdateCast(_evnt) {
        this.nextCast(_evnt);
    }

    set isViewOpen(_vl: boolean) {
        this.__isViewOpen = _vl;
        this.UpdateCast(this.__size);
    }
    get isViewOpen(): boolean {
        return this.__isViewOpen;
    }

    set isFormOpen(_vl: boolean) {
        this.__isFormOpen = _vl;
        this.UpdateCast(this.__size);
    }
    get isFormOpen(): boolean {
        return this.__isFormOpen;
    }

    set isFormBig(_vl: boolean) {
        this.__isFormBig = _vl;
        this.UpdateCast(this.__size);
    }
    get isFormBig(): boolean {
        return this.__isFormBig;
    }
    set isImportOpen(_vl: boolean) {
        this.__isImportOpen = _vl;
        this.UpdateCast(this.__size);
    }
    get isImportOpen(): boolean {
        return this.__isImportOpen;
    }

    set MobileSidebar(_vl: boolean) {
        this.__mobileSidebar = _vl;
        this.UpdateCast(this.__size);
    }
    get MobileSidebar(): boolean {
        return this.__mobileSidebar;
    }

    set Vertical(_vl: boolean) {
        this.__vertical = _vl;
        //this.UpdateCast(this.__size); 
    }
    get Vertical(): boolean {
        return this.__vertical;
    }


    getSize(_width, _height) {
        let szCntnr: SizeContainer = new SizeContainer();
        //if (_width <= 944) {
        szCntnr.Content.Width = 344;
        let clmn = Math.floor(_width / 305);
        //console.log(clmn);
        szCntnr.Sidebar.Width = clmn <= 1 ? 0 : 55;
        _width = _width - szCntnr.Sidebar.Width;
        //let ww = szCntnr.Sidebar.Width;
        szCntnr = this.getAllSize(clmn, _width, szCntnr);

        this.Vertical = szCntnr.Content.Width <= 650 ? true : false;
        //szCntnr.Form = this.getViewSize(clmn, _width, szCntnr).Form;
        //szCntnr.View = this.getViewSize(clmn, _width, szCntnr).View;
        //szCntnr.Content = this.getContentSize(clmn, _width, szCntnr).Content;
        //szCntnr.View = this.getViewSize(clmn, _width, szCntnr).View;
        //this.isFormOpen ? szCntnr.Form.Width = (this.isFormBig && ((this.isViewOpen && clmn > 3) || (!this.isViewOpen && clmn > 2))) ? szCntnr.Width * 2 : (clmn <= 1) ? _width : szCntnr.Width : null;
        //this.isViewOpen ? szCntnr.View.Width = _width - szCntnr.Form.Width - szCntnr.Content.Width : null;
        //szCntnr.Content.Width = (((this.isViewOpen || this.isViewOpen) && clmn <= 1) || (this.isViewOpen && this.isFormOpen && clmn <= 2)) ? 0 : _width - szCntnr.Form.Width - szCntnr.View.Width;
        //this.isViewOpen ? szCntnr.View.Width = _width - szCntnr.Form.Width - szCntnr.Content.Width : null;
        /* szCntnr.View.Width < 300 ? clmn-- : null;
        //console.log(clmn);
        this.isFormOpen ? szCntnr.Form.Width = (this.isFormBig && ((this.isViewOpen && clmn > 3) || (!this.isViewOpen && clmn > 2))) ? szCntnr.Width * 2 : (clmn <= 1) ? _width : szCntnr.Width : null;
        this.isViewOpen ? szCntnr.View.Width = _width - szCntnr.Form.Width - szCntnr.Content.Width : null;
        szCntnr.Content.Width = (((this.isViewOpen || this.isViewOpen) && clmn <= 1) || (this.isViewOpen && this.isFormOpen && clmn <= 2)) ? 0 : _width - szCntnr.Form.Width - szCntnr.View.Width;
        this.isViewOpen ? szCntnr.View.Width = _width - szCntnr.Form.Width - szCntnr.Content.Width : null; */

        ////console.log(_width - szCntnr.Form.Width);
        //(this.isFormBig && (_width - szCntnr.Form.Width) < 350) ? szCntnr.Form.Width = szCntnr.Width : null;
        /* szCntnr.Content.Width = this.isFormOpen ? _width - szCntnr.Form.Width : 300;
        if (this.isViewOpen) {
            szCntnr.View.Width = _width - szCntnr.Form.Width - szCntnr.Content.Width;
            if (szCntnr.View.Width < 300) {
                szCntnr.View.Width = _width - szCntnr.Form.Width;
                //szCntnr.Content.Width = szCntnr.Content.Width < 300 ? 0 : _width - szCntnr.Form.Width;
            }
            let ttlSz = szCntnr.Content.Width + szCntnr.Form.Width + szCntnr.View.Width;
            if (ttlSz > _width) {
                if (this.isFormBig && szCntnr.View.Width < 600) {
                    szCntnr.Form.Width = szCntnr.Width;
                    //szCntnr.Content.Width = 300;
                }
            }
            szCntnr.Content.Width = _width - szCntnr.Form.Width - szCntnr.View.Width;
            if (szCntnr.View.Width > 600) {
                szCntnr.Content.Width = 334;
                szCntnr.View.Width = _width - szCntnr.Form.Width - szCntnr.Content.Width;
            }
            if (szCntnr.View.Width < 300) {
                szCntnr.Content.Width = 0;
                szCntnr.View.Width = _width - szCntnr.Form.Width - szCntnr.Content.Width;
                if (szCntnr.View.Width < 300 && this.isFormOpen) {
                    szCntnr.View.Width = 0;
                    szCntnr.Form.Width = _width;
                }
            }
        } */
        //szCntnr.View.Width < 300 ? szCntnr.View.Width = _width - szCntnr.Form.Width - szCntnr.Content.Width: null;

        /* if (this.isFormOpen && this.isViewOpen) {
            szCntnr.Form.Width = (this.isFormBig) ? szCntnr.Width * 2 : szCntnr.Width;
            szCntnr.View.Width = szCntnr.Width;
        } else if (this.isViewOpen) {
            szCntnr.View.Width = szCntnr.Width * 2;
        } else if (this.isFormOpen) {
            szCntnr.Form.Width = (this.isFormBig) ? szCntnr.Width * 2 : szCntnr.Width;
        }
        //}
        if (szCntnr.Content.Width < szCntnr.Width) {
            szCntnr.Content.Width = 0;
            //szCntnr.View.Width = _width - szCntnr.Form.Width;
        } */
        /* if() */
        return szCntnr;
    }

    getAllSize(_clmn, _width, _szCntnr) {
        _szCntnr = this.getFormSize(_clmn, _width, _szCntnr);
        if (this.isViewOpen && _szCntnr.View.Width < 300) {
            if (_szCntnr.Form.Width === 600) {
                _szCntnr.Form.Width = 400;
                _szCntnr.View = this.getViewSize(_clmn, _width, _szCntnr).View;
            } else if (_szCntnr.Content.Width > 0) {
                _szCntnr.Content.Width = 0;
                _szCntnr.View = this.getViewSize(_clmn, _width, _szCntnr).View;
                if (_szCntnr.View.Width < 300) {
                    _szCntnr.View.Width = 0;
                    _szCntnr.Form.Width = _width;
                }
            } else {
                _szCntnr.Content.Width = 0;
                _szCntnr.View.Width = 0;
                _szCntnr.Form.Width = _width;
            }
        }
        return _szCntnr;
    }
    getFormSize(_clmn, _width, _szCntnr) {
        _szCntnr.Form.Width = this.isFormOpen ? (this.isFormBig && ((this.isViewOpen && _clmn > 3) || (!this.isViewOpen && _clmn > 4))) ? _szCntnr.Width * 3 : (_clmn <= 1) ? _width : _szCntnr.Width : 0;
        _szCntnr.Content = this.getContentSize(_clmn, _width, _szCntnr).Content;
        return _szCntnr;
    }
    getViewSize(_clmn, _width, _szCntnr) {
        _szCntnr.View.Width = this.isViewOpen ? _width - _szCntnr.Form.Width - _szCntnr.Content.Width : 0;
        return _szCntnr;
    }
    getContentSize(_clmn, _width, _szCntnr) {
        _szCntnr.View = this.getViewSize(_clmn, _width, _szCntnr).View;
        _szCntnr.Content.Width = (((this.isViewOpen || this.isViewOpen) && _clmn <= 1) || (this.isViewOpen && this.isFormOpen && _clmn <= 2)) ? 0 : _width - _szCntnr.Form.Width - _szCntnr.View.Width;
        _szCntnr.View = this.getViewSize(_clmn, _width, _szCntnr).View;
        return _szCntnr;
    }

}

export class SizeContainer {
    Width = 300;
    Content: Size = new Size();
    /*Content =  {
        Width: 0,
        Height: 0
    } */
    View: Size = new Size();
    /* View = {
        Width: 0,
        Height: 0
    } */
    Form: Size = new Size();
    /* Form = {
        Width: 0,
        Height: 0
    } */
    Sidebar: Size = new Size();
    /* Sidebar = {
        Width: 0,
        Height: 0
    } */
}

export class Size {
    Width = 0;
    Height = 0
}